import React from "react";
import { Button, useWizard } from "@picklebet/ui";
import { MethodRow } from "../../method-row/MethodRow";
import { useDepositWizard } from "features/wallet/components/deposit/hooks/useDepositWizard";
import type { DepositMethodStepName } from "features/wallet/components/deposit/utils/registry";

export const DepositMethodField = () => {
  const { selectedMethod, selectableMethods, destinations, submitting } =
    useDepositWizard();
  const { push } = useWizard<DepositMethodStepName>();

  const canChangeMethod = selectableMethods.length + destinations.length > 1;
  const { PickerAction } = selectedMethod;

  return (
    <MethodRow
      icon={<selectedMethod.Icon />}
      label={selectedMethod.label}
      trailing={
        canChangeMethod ? (
          <Button
            size="sm"
            disabled={submitting}
            onClick={() => push("deposit-method")}
          >
            Change
          </Button>
        ) : (
          typeof PickerAction !== "undefined" && (
            <PickerAction variant="primary" />
          )
        )
      }
    />
  );
};
